import { render, staticRenderFns } from "./SalesRestriction.vue?vue&type=template&id=fe799946"
import script from "./SalesRestriction.vue?vue&type=script&lang=js"
export * from "./SalesRestriction.vue?vue&type=script&lang=js"
import style0 from "./SalesRestriction.vue?vue&type=style&index=0&id=fe799946&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports